import { validators } from "../../utils/validators";
import { inputValidTargetAttrName } from "../../const/const";

const isFormInvalid = (err) => {
  if (Object.keys(err).length > 0) return true;
  return false;
};

const findInputError = (errors, name) => {
  const filtered = Object.keys(errors)
    .filter((key) => key.includes(name))
    .reduce((cur, key) => {
      return Object.assign(cur, { error: errors[key] });
    }, {});
  return filtered;
};

const validateInputs = (opt) => {
  const targetScroll = opt?.targetScroll;
  const inputsToValidate = document.querySelectorAll(
    `[${inputValidTargetAttrName}]`,
  );

  for (const inputEl of inputsToValidate) {
    const validationType = inputEl.getAttribute("valid-type");
    const inputValue = inputEl.value;
    const fieldTitle =
      inputEl.getAttribute("valid-title") || inputEl.getAttribute("title");

    const validatorFn = validators[validationType];

    if (!validatorFn?.(inputValue)) {
      if (targetScroll) {
        inputEl.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      return {
        isValid: false,
        invalidElement: inputEl,
        invalidTitle: fieldTitle,
      };
    }
  }

  return {
    isValid: true,
    invalidElement: null,
    invalidTitle: null,
  };
};

export { findInputError, isFormInvalid, validateInputs };
